module.exports = require('./helpers/bundle-url').getBundleURL('hROql') + "logo.c51670a8.svg";